module.exports = __webpack_public_path__ + "img/4Goutdoors.7be6de9d.jpg";